import { Card } from 'antd';
import { DoctorIcon } from 'shared/components/Icons';
import { Text } from 'shared/components/Text';
import { useTranslationCustom } from 'shared/utils/hooks/useTranslationCustom';
import { useSelector } from 'react-redux';
import { getAffiliateGlobalStylesSelector } from 'store/app/app.redux';

import classes from './styles.module.scss';

const { Meta } = Card;

const NewVisitCard = () => {
  const t = useTranslationCustom();
  const affiliateGlobalStyles = useSelector(getAffiliateGlobalStylesSelector);

  return (
    <>
      <div className={classes.card}>
        <img
          className={classes.cardImage}
          alt="example"
          src={
            affiliateGlobalStyles?.dashboardImage
              ? affiliateGlobalStyles?.dashboardImage
              : '/assets/images/StartNewOrder.jpg'
          }
        />
        <Meta
          title={
            <div className={classes.title_icon}>
              <DoctorIcon color="#A3ACBA" />
              <Text type={'m-heading'}>
                {t('dashboard.newVisitCardTitle', 'Patient Portal')}
              </Text>
            </div>
          }
          description={
            <Text type={'sf-body'}>
              {t(
                'dashboard.newVisitCardDescription',
                'Access and manage your medical records, securely communicate with healthcare providers, and conveniently view test results,providing you with a comprehensive and streamlined healthcare experience.'
              )}
            </Text>
          }
        />
        {/* <div className={classes.buttonWrapper}>
          <Button key={'newOrderButton'} className={classes.actionButtonWhite}>
            <a
              target="_blank"
              href={Urls.GettingStarted}
              rel="noopener noreferrer"
            >
              <Text type="sf-body-medium-two">Schedule a Visit</Text>
            </a>
          </Button>
          <Button
            key={'newOrderButton'}
            type={'primary'}
            className={classes.actionButton}
          >
            <a
              target="_blank"
              href={Urls.GettingStarted}
              rel="noopener noreferrer"
            >
              <Text type="sf-body-medium-two" color="white-02">
                Start a New Visit
              </Text>
            </a>
          </Button>
        </div> */}
      </div>
    </>
  );
};

export default NewVisitCard;
